module.exports = __webpack_public_path__ + "static/media/logo+name.3ba6a8ce.png";